/**
 * Asynchronously loads the component for AssetPage
 */

import { lazyLoad } from 'utils/loadable'

export const OrdersPage = lazyLoad(
	() => import('./index'),
	module => module.OrdersPage
)
